import _ from 'lodash'
import Vue from 'vue'

export const getClientes = ({ state, commit }, params = null) => {
  let user = _.get(params, 'user', null)
  if (user === null) user = state.app.user
  if (user === null || !user.consultoria || !user.consultoria.id) return []
  return Vue.prototype.axios.post('consultoria/clientes', { id: user.consultoria.id }).then(r => {
    commit('setClientes', { clientes: r.data.data })
    let cliente = JSON.parse(localStorage.getItem('cliente'))
    if (cliente && cliente !== null) commit('setClienteSelecionado', { cliente: cliente })
    return state.app.consultoria.clientes
  })
}

export const setClienteSelecionado = ({ state, commit }, { cliente = null, clienteID = null }) => {
  let clientes = state.app.consultoria.clientes
  console.log({ clienteID, clientes, cliente })
  if (cliente === null && clienteID !== null) {
    let clientes_ = clientes.filter(c => c.id === clienteID)
    if (clientes_ === null || clientes_.length === 0) {
      if (clienteID === -1) {
        return null
      } else {
        localStorage.removeItem('cliente')
        commit('setClienteSelecionado')
      }
      return null
    }
    cliente = clientes_[0]
  }
  if (cliente === null) return null
  localStorage.setItem('cliente', JSON.stringify(cliente))
  commit('setClienteSelecionado', cliente)
  return cliente
}
